import * as swcHelpers from '@swc/helpers';
import React, { useState, useEffect } from 'react';
import { LocaleUtils } from '@grandvisionhq/utils';
import { useCookieConsentContext } from '../context/CookieConsentContext.js';
import { isCookieCategoryEnabled } from '../provider/onetrust-provider.js';

function OneTrustCookieConsent(props) {
    const { locale , isMultilingual , src , domain , skipScriptAfterConsent , ScriptComponent  } = props;
    const [selectedLocale, setSelectedLocale] = useState('');
    const consentResult = useCookieConsentContext();
    useEffect(()=>{
        // check if the banner is multilingual
        if (isMultilingual) {
            var ref;
            const cookieLocale = (ref = LocaleUtils.getLocaleFromCookie()) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (cookieLocale) {
                setSelectedLocale(cookieLocale);
            }
        // else: user has not selected a locale yet
        } else {
            // in case of unilingual, set the locale
            setSelectedLocale(locale);
        }
    }, [
        locale,
        isMultilingual
    ]);
    if (skipScriptAfterConsent && isCookieCategoryEnabled('required', consentResult)) {
        // Don't load the cookie script again if it has already been accepted
        // for OpCos that don't allow to change your cookie settings afterwards
        return null;
    }
    if (!src || !domain) {
        console.error(`Unable to initiate OneTrust with {${JSON.stringify({
            src,
            domain
        })}}`);
        return null;
    }
    if (!selectedLocale) return null;
    const [language] = selectedLocale.split('-');
    const scriptProps = {
        src,
        type: 'text/javascript',
        charSet: 'UTF-8',
        crossOrigin: 'anonymous',
        'data-language': language,
        'data-domain-script': domain
    };
    return ScriptComponent ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ScriptComponent, swcHelpers.extends({}, scriptProps)), /*#__PURE__*/ React.createElement(ScriptComponent, null, 'function OptanonWrapper() {}')) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("script", swcHelpers.extends({}, scriptProps)), /*#__PURE__*/ React.createElement("script", {
        type: "text/javascript"
    }, 'function OptanonWrapper() {}'));
}

export { OneTrustCookieConsent };
//# sourceMappingURL=onetrust-cookie-consent.js.map
